import { withForm } from "~/components/form/app-form";
import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card";

import { offerFormOptions } from "../offer-form-options";

export const AboutSection = withForm({
  ...offerFormOptions,
  props: {} as { canUseOfferPage: boolean },
  render: function Render({ form, canUseOfferPage }) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>About</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {canUseOfferPage && (
            <>
              <form.AppField name="vslVideoUrl">
                {(field) => (
                  <field.TextField
                    label="VSL (Video Sales Letter) Video URL"
                    helpText="We're working on letting you directly upload videos. For now, you can use a service like YouTube or Vimeo and paste the video URL here."
                    type="url"
                  />
                )}
              </form.AppField>

              <form.AppField name="preHeadline">
                {(field) => <field.TextField label="Pre-Headline" />}
              </form.AppField>
            </>
          )}

          <form.AppField name="headline">
            {(field) => (
              <field.TextField
                label="Headline: benefit-centric statement about your main coaching offer"
                aiFill
              />
            )}
          </form.AppField>

          <form.AppField name="description">
            {(field) => (
              <field.TextareaField
                label="Description of the coaching offer"
                maxLength={300}
              />
            )}
          </form.AppField>

          <form.AppField name="applicationDeadline">
            {(field) => (
              <field.TextField
                label="Application Deadline (if applicable)"
                type="date"
              />
            )}
          </form.AppField>

          <form.AppField name="cohortStartDate">
            {(field) => (
              <field.TextField
                label="Cohort Start Date (if applicable)"
                type="date"
              />
            )}
          </form.AppField>
        </CardContent>
      </Card>
    );
  },
});
